import { get } from 'lodash';
import { connect } from 'react-redux';
import LoginEventSender from '../components/LoginEventSender';

export default connect((state) => ({
  user: get(state, 'user.customerDetails'),
}))(LoginEventSender);
